module.exports = __webpack_public_path__ + "img/icon_BRKb.a0681ca6.png";